<script setup lang="ts">
import type { Subscription, SubscriptionOrder } from '@entities/subscription'

import { faArrowUpRightFromSquare, faArrowsRotate, faLinkSimple } from '@fortawesome/pro-regular-svg-icons'

import { AppDropdown, AppDropdownItem } from '@shared/ui/dropdowns'
import { BtnIcon } from '@shared/ui/buttons'

import { useSubscriptionOrderActions } from '../model/subscription-order-actions.hook'

defineOptions({
  name: 'SubscriptionOrderActions',
})

const props = defineProps<{
  order: SubscriptionOrder
  subscription: Subscription
  /** `manage-orders`, resolved once by the table rather than per payment row. */
  canManage: boolean
}>()

const {
  isOpen,
  containerRef,
  floatingRef,
  floatingStyles,
  triggerIcon,
  isRetryVisible,
  toggle,
  openOrder,
  syncOrder,
  openRetry,
} = useSubscriptionOrderActions({
  order: computed(() => props.order),
  subscription: computed(() => props.subscription),
  canManage: computed(() => props.canManage),
})
</script>

<template>
  <div
    ref="containerRef"
    class="subscription-order-actions"
  >
    <BtnIcon
      :icon="triggerIcon"
      view="table"
      :title="`Actions for order #${order.id}`"
      @click="toggle"
    />
    <div
      v-if="isOpen"
      ref="floatingRef"
      class="subscription-order-actions__floating"
      :style="floatingStyles"
    >
      <AppDropdown>
        <AppDropdownItem
          text="View order"
          color="blue"
          :prepend-icon="faArrowUpRightFromSquare"
          @click="openOrder"
        />
        <AppDropdownItem
          v-if="canManage"
          text="Sync order"
          color="blue"
          :prepend-icon="faLinkSimple"
          @click="syncOrder"
        />
        <AppDropdownItem
          v-if="isRetryVisible"
          text="Retry payment"
          color="blue"
          :prepend-icon="faArrowsRotate"
          @click="openRetry"
        />
      </AppDropdown>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./SubscriptionOrderActions.scss" />
